import React from 'react';
import {
  AutoComplete,
  List,
  ListItem,
  MenuItem,
} from 'material-ui';

const printUser = ({ fullName, superUser }) => `${fullName || ''}${superUser ? ' (super user)' : ''}`;
const printVenue = ({ venues }) => (venues || []).join(' | ');


class UserPicker extends React.Component {
  state = {
    text: '',
  }

  onChange = (text) => {
    this.setState({
      text,
    });
  }

  getListItems = (selected) => {
    const toListItem = (user) => {
      const userStr = printUser(user);
      const venuesStr = printVenue(user);
      return (
        <ListItem
          key={user.uid}
          hoverColor="rgba(183, 28, 28, 0.5)"
          style={{ display: 'flex', alignItems: 'center' }}
          innerDivStyle={{ lineHeight: 'normal' }}
          onClick={() => this.removeUser(user.uid)}
        >
          <div>{userStr}</div>
          <div style={{ color: 'grey', fontSize: '12px' }}>{venuesStr}</div>
        </ListItem>
      );
    };
    const list = (selected || []);
    return list
      .filter((id) => this.props.users.findIndex((u) => u.uid === id) > -1)
      .map((id) => this.props.users.find((u) => u.uid === id))
      .map(toListItem);
  }

  getMenuItem = (user) => {
    const userStr = printUser(user);
    const venuesStr = printVenue(user);
    return {
      text: userStr,
      value: (
        <MenuItem
          key={user.uid || user.fullName}
          style={{ display: 'flex', alignItems: 'center' }}
          innerDivStyle={{ lineHeight: 'normal' }}
        >
          <div>{userStr}</div>
          <div style={{ color: 'grey', fontSize: '12px' }}>{venuesStr}</div>
        </MenuItem>
      ),
      user,
    };
  };

  selectUser = ({ user }) => {
    const { selected } = this.props;
    const userIsNotSelected = (selected || [])
      .findIndex((id) => user && id === user.uid) < 0;
    if (userIsNotSelected) {
      const next = [...selected, user.uid];
      this.props.onChange(next);
    }
    this.setState({
      text: '',
    });
  }

  removeUser = (idToRemove) => {
    const { selected } = this.props;
    const removeIdx = selected.findIndex((id) => id === idToRemove);
    if (removeIdx > -1) {
      const next = [
        ...selected.slice(0, removeIdx),
        ...selected.slice(removeIdx + 1),
      ];
      this.props.onChange(next);
    }
  }

  render() {
    const { label, selected, users, ...rest } = this.props;
    return (
      <>
        <AutoComplete
          floatingLabelText={label}
          dataSource={users.map(this.getMenuItem)}
          searchText={this.state.text}
          onUpdateInput={this.onChange}
          onNewRequest={this.selectUser}
          filter={AutoComplete.caseInsensitiveFilter}
          maxSearchResults={5}
          menuProps={{ maxHeight: 250 }}
          {...rest}
        />
        <List
          style={{
            maxHeight: '280px',
            overflowY: 'scroll',
          }}
        >
          {this.getListItems(selected)}
        </List>
      </>
    );
  }
}

export default UserPicker;
